import { render, staticRenderFns } from "./TextEditorPDPA.vue?vue&type=template&id=5a41c5a4&scoped=true"
import script from "./TextEditorPDPA.vue?vue&type=script&lang=js"
export * from "./TextEditorPDPA.vue?vue&type=script&lang=js"
import style0 from "./TextEditorPDPA.vue?vue&type=style&index=0&id=5a41c5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41c5a4",
  null
  
)

export default component.exports